export const getCurrentUser = (state) => {
    return state?.user?.user?.[0] || {}
}